import isAuthenticated from "@/routes/middleware/isAuthenticated";
import metatags from "@/routes/middleware/metatags";
import multiguard from "vue-router-multiguard";
import permissions from "@/routes/middleware/permissions";
import myProfile from "@/routes/middleware/myProfile";
const routes = [];
const requireRoute = require.context(
  // The relative path of the routes folder
  "@/modules",
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base route filenames
  /routes\/admin\.js$/
);

requireRoute.keys().forEach((route) => {
  const routeConfig = requireRoute(route);

  routeConfig.default.forEach((route) => {
    route.beforeEnter = multiguard([myProfile]);
    routes.push(route);
  });
});

export default {
  path: "/admin",
  name: "admin",
  redirect: { name: "dashboard" },
  component: () => import("@/components/Layouts/Dashboard.vue"),
  meta: { title: "Admin", authenticatable: false },
  children: routes,
  // beforeEnter: multiguard([metatags, tokenVerifier]),
  beforeEnter: multiguard([metatags, isAuthenticated, permissions]),
};
